<div class="service-view-old-layout">
    <div class="service-view-old-flex">
        <div class="service-view-old-flex-column">
            <div class="service-view-old-flex">
                <div class="service-view-old-block no-margin-top">
                    <div class="service-view-old-side">
                        <div class="service-view-old-side-header" [ngStyle]="{'height': rowAreaHeight.row1.rowHeight}">
                            <div class="service-view-old-side-header-text">Biz Process</div>                                
                        </div>
                    </div>
                    <div class="service-view-old-area-holder area-holder-border bps" [ngStyle]="{'height': rowAreaHeight.row1.areaHeight}">
                        <div class="service-view-old-area-header">Insurance, BPaaS & BPO</div>
                        <div class="entity-holder">
                            <ng-container *ngFor="let entity of entityData.bps.data">            
                                <app-entity [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="service-view-old-block no-margin-top">
                    <div class="service-view-old-side">
                        <div class="service-view-old-side-header" [ngStyle]="{'height': rowAreaHeight.row1.rowHeight}">
                            <div class="service-view-old-side-header-text">Workplace</div>                                
                        </div>
                    </div>
                    <div class="service-view-old-area-holder area-holder-border devices" [ngStyle]="{'height': rowAreaHeight.row1.areaHeight}">
                        <div class="service-view-old-area-header">Devices</div>
                        <div class="entity-holder">
                            <ng-container *ngFor="let entity of entityData.devices.data">            
                                <app-entity [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="service-view-old-block no-margin-top">
                    <div class="service-view-old-area-holder area-holder-border collaboration" [ngStyle]="{'height': rowAreaHeight.row1.areaHeight}">
                        <div class="service-view-old-area-header">Collaboration</div>
                        <div class="entity-holder">
                            <ng-container *ngFor="let entity of entityData.collaboration.data">            
                                <app-entity [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="service-view-old-block no-margin-top">
                    <div class="service-view-old-area-holder area-holder-border asset" [ngStyle]="{'height': rowAreaHeight.row1.areaHeight}">
                        <div class="service-view-old-area-header">Asset Management</div>
                        <div class="entity-holder">
                            <ng-container *ngFor="let entity of entityData.asset.data">            
                                <app-entity [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <div class="service-view-old-flex">
                <div class="service-view-old-flex-column">
                    <div class="service-view-old-flex">
                        <div class="service-view-old-block">
                            <div class="service-view-old-side">
                                <div class="service-view-old-side-header" [ngStyle]="{'height': rowAreaHeight.row2.rowHeight}">
                                    <div class="service-view-old-side-header-text">Engineering</div>                                
                                </div>
                            </div>
                            <div class="service-view-old-area-holder area-holder-border engineering" [ngStyle]="{'height': rowAreaHeight.row2.areaHeight}">
                                <div class="service-view-old-area-header">Engineering</div>
                                <div class="entity-holder">
                                    <ng-container *ngFor="let entity of entityData.engineering.data">            
                                        <app-entity [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity>                                        
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                        <div class="service-view-old-block">
                            <div class="service-view-old-side">
                                <div class="service-view-old-side-header" [ngStyle]="{'height': rowAreaHeight.row2.rowHeight}">
                                    <div class="service-view-old-side-header-text">Analytics</div>                                
                                </div>
                            </div>
                            <div class="service-view-old-area-holder area-holder-border analytics" [ngStyle]="{'height': rowAreaHeight.row2.areaHeight}">
                                <div class="service-view-old-area-header">Analytics</div>
                                <div class="entity-holder">
                                    <ng-container *ngFor="let entity of entityData.analytics.data">            
                                        <app-entity [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity>                                        
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                        <div class="service-view-old-block">
                            <div class="service-view-old-side">
                                <div class="service-view-old-side-header" [ngStyle]="{'height': rowAreaHeight.row2.rowHeight}">
                                    <div class="service-view-old-side-header-text">Data Services</div>                                
                                </div>
                            </div>
                            <div class="service-view-old-area-holder area-holder-border data" [ngStyle]="{'height': rowAreaHeight.row2.areaHeight}">
                                <div class="service-view-old-area-header">Information / Data / Knowledge Management</div>
                                <div class="entity-holder">
                                    <ng-container *ngFor="let entity of entityData.data.data">            
                                        <app-entity [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity>                                        
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="service-view-old-flex">
                        <div class="service-view-old-block">
                            <div class="service-view-old-side">
                                <div class="service-view-old-side-header" [ngStyle]="{'height': rowAreaHeight.row3.rowHeight}">
                                    <div class="service-view-old-side-header-text">Applications</div>                                
                                </div>
                            </div>
                            <div class="service-view-old-area-holder area-holder-border managedapp" [ngStyle]="{'height': rowAreaHeight.row3.areaHeight}">
                                <div class="service-view-old-area-header">Managed Applications</div>
                                <div class="entity-holder">
                                    <ng-container *ngFor="let entity of entityData.managedapp.data">            
                                        <app-entity [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity>                                        
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                        <div class="service-view-old-block">
                            <div class="service-view-old-area-holder area-holder-border enterpriseapp" [ngStyle]="{'height': rowAreaHeight.row3.areaHeight}">
                                <div class="service-view-old-area-header">Enterprise Applications</div>
                                <div class="entity-holder">
                                    <ng-container *ngFor="let entity of entityData.enterpriseapp.data">            
                                        <app-entity [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity>                                        
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                        <div class="service-view-old-block">
                            <div class="service-view-old-area-holder area-holder-border modernization" [ngStyle]="{'height': rowAreaHeight.row3.areaHeight}">
                                <div class="service-view-old-area-header">App Dev / Testing & Modernization</div>
                                <div class="entity-holder">
                                    <ng-container *ngFor="let entity of entityData.modernization.data">            
                                        <app-entity [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity>                                        
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="service-view-old-block service-view-old-flex-column">
                        <div class="security-header">
                            <div class="service-view-old-area-header2">Security</div>
                        </div>
                        <div class="service-view-old-area-holder area-holder-border security" [ngStyle]="{'height': getC2Height()}">
                            <div class="entity-holder">
                                <ng-container *ngFor="let entity of entityData.security.data">            
                                    <app-entity [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity>                                        
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="service-view-old-flex">
                <div class="service-view-old-block">
                    <div class="service-view-old-side">
                        <div class="service-view-old-side-header" [ngStyle]="{'height': rowAreaHeight.row4.rowHeight}">
                            <div class="service-view-old-side-header-text">Cloud</div>                                
                        </div>
                    </div>
                    <div class="service-view-old-area-holder area-holder-border iaas" [ngStyle]="{'height': rowAreaHeight.row4.areaHeight}">
                        <div class="service-view-old-area-header">IaaS</div>
                        <div class="entity-holder">
                            <ng-container *ngFor="let entity of entityData.iaas.data">            
                                <app-entity [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="service-view-old-block">
                    <div class="service-view-old-area-holder area-holder-border paas" [ngStyle]="{'height': rowAreaHeight.row4.areaHeight}">
                        <div class="service-view-old-area-header">PaaS</div>
                        <div class="entity-holder">
                            <ng-container *ngFor="let entity of entityData.paas.data">            
                                <app-entity [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="service-view-old-block">
                    <div class="service-view-old-area-holder area-holder-border hybrid" [ngStyle]="{'height': rowAreaHeight.row4.areaHeight}">
                        <div class="service-view-old-area-header">Hybrid / Multi-Cloud / Edge</div>
                        <div class="entity-holder">
                            <ng-container *ngFor="let entity of entityData.hybrid.data">            
                                <app-entity [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="service-view-old-flex-column">
            <div class="service-view-old-block no-margin-top no-margin-right service-view-old-flex-column">
                <div class="consulting-header">
                    <div class="service-view-old-area-header2">Consulting</div>
                </div>
                <div class="service-view-old-area-holder area-holder-border consulting" [ngStyle]="{'height': getC4Height()}">
                    <div class="entity-holder">
                        <ng-container *ngFor="let entity of entityData.consulting.data">            
                            <app-entity [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity>                                        
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="service-view-old-block no-margin-right service-view-old-flex-column">
                <div class="analysts-header">
                    <div class="service-view-old-area-header2">Analysts</div>
                </div>
                <div class="service-view-old-area-holder area-holder-border analysts" [ngStyle]="{'height': getC5Height()}">
                    <div class="entity-holder">
                        <ng-container *ngFor="let entity of entityData.analysts.data">            
                            <app-entity [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity>                                        
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="service-view-old-flex">
        <div>
            <div class="service-view-old-block no-margin-right">
                <div class="service-view-old-side">
                    <div class="service-view-old-side-header" [ngStyle]="{'height': getInfraHeight()}">
                        <div class="service-view-old-side-header-text">Infrastructure</div>                                
                    </div>
                </div>
            </div>
        </div>
        <div class="service-view-old-flex-column">
            <div class="service-view-old-flex">
                <div class="service-view-old-block">
                    <div class="service-view-old-area-holder area-holder-border server" [ngStyle]="{'height': rowAreaHeight.row5.areaHeight}">
                        <div class="service-view-old-area-header">Server / Compute</div>
                        <div class="entity-holder">
                            <ng-container *ngFor="let entity of entityData.server.data">            
                                <app-entity [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="service-view-old-block">
                    <div class="service-view-old-area-holder area-holder-border mainframe" [ngStyle]="{'height': rowAreaHeight.row5.areaHeight}">
                        <div class="service-view-old-area-header">Mainframe</div>
                        <div class="entity-holder">
                            <ng-container *ngFor="let entity of entityData.mainframe.data">            
                                <app-entity [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="service-view-old-block">
                    <div class="service-view-old-area-holder area-holder-border storage" [ngStyle]="{'height': rowAreaHeight.row5.areaHeight}">
                        <div class="service-view-old-area-header">Storage & Backup</div>
                        <div class="entity-holder">
                            <ng-container *ngFor="let entity of entityData.storage.data">            
                                <app-entity [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <div class="service-view-old-flex">
                <div class="service-view-old-block">
                    <div class="service-view-old-area-holder area-holder-border datacenter" [ngStyle]="{'height': rowAreaHeight.row6.areaHeight}">
                        <div class="service-view-old-area-header">Data Center</div>
                        <div class="entity-holder">
                            <ng-container *ngFor="let entity of entityData.datacenter.data">            
                                <app-entity [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity>                                        
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="service-view-old-block">
                <div class="service-view-old-area-holder area-holder-border network" [ngStyle]="{'height': getC1Height()}">
                    <div class="service-view-old-area-header">Network & Telecom</div>
                    <div class="entity-holder">
                        <ng-container *ngFor="let entity of entityData.network.data">            
                            <app-entity [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity>                                        
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="service-view-old-block no-margin-right service-view-old-flex-column">
                <div class="systemsupport-header">
                    <div class="service-view-old-area-header2">Support</div>
                </div>
                <div class="service-view-old-area-holder area-holder-border systemsupport" [ngStyle]="{'height': getC3Height()}">
                    <div class="entity-holder">
                        <ng-container *ngFor="let entity of entityData.systemsupport.data">            
                            <app-entity [viewType]="entityViewType" [data]="entity" [pageView]="pageView" (edit)="editEntity($event)"></app-entity>                                        
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
